module.exports = __webpack_public_path__ + "static/media/Close.2e7f9dbe.svg";